const getMonthName = (year: number, month: number): string => {
  const rawMonthName = new Intl.DateTimeFormat("pl-PL", {
    month: "long",
  }).format(new Date(year, month));

  const monthName = `${rawMonthName.charAt(0).toUpperCase()}${rawMonthName.slice(1)}`;
  return monthName;
};

export default getMonthName;
